import React from 'react'
import { TwitterPicker, ColorResult, BlockPicker } from 'react-color'

type Props = {
  label?: string
  value: string
  onChange: (color: string) => void
  presetColors?: string[]
}

export default function ColorPickerField ({
  label = 'Цвет',
  value,
  onChange,
  presetColors = [ '#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF' ]
}: Props) {
  const handleChange = (color: ColorResult) => {
    onChange(color.hex)
  }

  return (
    <div style={{ marginBottom: 16 }}>
      {label && <label style={{ display: 'block', marginBottom: 8 }}>{label}</label>}

      <BlockPicker
        color={value}
        onChangeComplete={handleChange}
        colors={presetColors}
        triangle="hide"
      />

      <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
        <div style={{
          width: 32,
          height: 32,
          borderRadius: 4,
          backgroundColor: value,
          border: '1px solid #ccc'
        }} />
        <span>{value}</span>
      </div>
    </div>
  )
}
